module.exports = __webpack_public_path__ + "media/images/mashable-e1de08ce6b936cba683dd0b34f25a92c03ea7d8bed17a4ce5313ac3efa810d14.jpg";